import i18n from "i18next";

export function formattedDate(data: string) {
    if (data === "") {
        return ""
    }
    const date = new Date(data)

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 01~12월
    const day = String(date.getDate()).padStart(2, '0');
    const options: Intl.DateTimeFormatOptions = {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true 
    };

    const formattedTime = new Intl.DateTimeFormat(i18n.language, options).format(date);

    return `${year}. ${month}. ${day}. ${formattedTime}`;
}

export function replaceName(data: string) {
    const cleaned = data.replace(/-C\d+\b/gi, '').trim();
    return cleaned.replace(/\s+\(/g, ' (');
    // return data.replace(/\b\d+(\.\d+)?\b\s*/g, '').replace(/ +/g, ' ').trim();
}